var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zj-home"},[_vm._v(" Home Page ")])
}
var staticRenderFns = []

export { render, staticRenderFns }